<template>
	<div class="chat-record">
		<div class="chat-record-title">
			聊天记录
		</div>
		<audio ref="audio" autoplay="autoplay" id="audio" style="visibility: hidden;"></audio>
		<video autoplay="autoplay" class="video" :src="videoSrc" v-show="videoSrc"></video>
		<i class="iconfont iconquxiao close-video" v-show="videoSrc" @click="closeVideo"></i>
		<ul :class="['chat-record-list',show_search_input ? 'has_input' : 'no_input']" v-infinite-scroll="bottomLoading"
		 :infinite-scroll-disabled="false">
			<div class="message-item-bytime clearfix" v-for="(v,i) in chatList">
				<div class="message-time">{{v[0].add_time}}</div>
				<div class="message-item" v-for="(item,index) in v">
					<div :class="['message-item-name',item.send_id==User_code?'self-name':'chat-name']">{{item.send_id==User_code?username:chat_name}} <span>{{item.add_time_hour}}</span></div>
					<!-- 0文字，1语音，2图片，3视频 4核对订单 5表情包 -->
					<div v-if="item.msg_type==0" class="message-item-content">{{item.message}}</div>
					<div v-if="item.msg_type==1" class="message-item-content">
						<i class="iconfont iconyuyin2" @click="playAudio(item.message)"></i>
					</div>
					<div v-if="item.msg_type==2" class="message-item-content">
						<el-image style="width: 100px; height: 100px" :src="url+item.message" :preview-src-list="[url+item.message]">
						</el-image>
					</div>
					<div v-if="item.msg_type==3" class="message-item-content">
						<img src="@/static/default-video.png" @click="playVideo(item.message)">
					</div>
					<div v-if="item.msg_type==4" class="message-item-content">
						<span class="order">
							<span class="order-title">请你核对订单信息</span>
							<span class="order-goods">
								<span class="order-goods-left">
									<img :src="item.message.goods_image" />
								</span>
								<span class="order-goods-right clearfix">
									<span class="order-goods-name text-ellipsis" v-if="item.message.goods_name">{{item.message.goods_name}}</span>
									<span class="order-goods-num" v-if="item.message.open_quantity">共{{item.message.open_quantity}}件商品</span>
									<span class="order-goods-totalprice" v-if="item.message.open_orderprice">合计￥{{item.message.open_orderprice}}</span>
								</span>
							</span>
							<span class="order-username" v-if="item.message.consignee">姓名:{{item.message.consignee}}</span>
							<span class="order-phone" v-if="item.message.phone_mob">电话:{{item.message.phone_mob}}</span>
							<span class="order-address" v-if="item.message.open_address">地址:{{item.message.open_address}}</span>
						</span>
					</div>
					<div v-if="item.msg_type==5" class="message-item-content">
						<img :src="item.message">
					</div>
					<p v-if="item.msg_type==6" :class="['message-img','clearfix','message-goods',item.is_new==0&&item.send_id==User_code ? 'message-lable' : '']">
						<span class="goods-left">
							<img :src="item.message.default_image" />
						</span>
						<span class="goods-right clearfix">
							<span class="msg-goods-name text-ellipsis">{{item.message.goods_name}}</span>
							<span class="msg-goods-price">￥{{item.message.price}}</span>
						</span>
					</p>
				</div>
			</div>
		</ul>
		<div class="chat-foot">
			<div class="foot-search" v-show="show_search_input">
				<div class="input-box">
					<span class="choose-time" @click="toggleSearchTime">
						<span>{{chatTimeRound}}</span><i class="iconfont iconbelow-s"></i>
						<div v-show="showSearchTime" class="time-quantum">
							<li data-time="4" data-text="最近一周" class="time-quantum-item">最近一周</li>
							<li data-time="3" data-text="最近一个月" class="time-quantum-item">最近一个月</li>
							<li data-time="2" data-text="最近三个月" class="time-quantum-item">最近三个月</li>
							<li data-time="1" data-text="最近一年" class="time-quantum-item">最近一年</li>
							<li data-time="0" data-text="全部" class="time-quantum-item">全部</li>
						</div>
					</span>
					<input type="text" class="input-text" v-model="search_str" @keyup.enter="searchByTime">
					<i class="iconfont iconyoujiantou" @click="searchByTime"></i>
				</div>
			</div>
			<div class="foot-bar">
				<Calendar v-show="show_calendar" class="calendar" @choseDay="choseDay"></Calendar>
				<i class="iconfont iconziyuan" @click="toggleSearch"></i>
				<i class="iconfont iconrili" @click="toggleCalendar"></i>
			</div>
		</div>
	</div>
</template>

<script>
	import Calendar from 'vue-calendar-component';
	export default {
		name: 'ChatRecord',
		data() {
			return {
				chatList: [], //聊天记录列表
				page: 0, //当前页数
				limit: 10,
				ulHeight: null, //ul的高度
				chatTimeRound: '全部', //聊天时间范围
				time: 0, //聊天时间范围字段 0 全部，1最近一年，2最近三个月，3最近一个月，4最近一周
				show_search_input: false, // 是否显示搜索弹窗
				showSearchTime: false, //是否显示时间段选择
				date: null, // 日期
				show_calendar: false, //是否显示日历
				search_str: '', //搜索关键字
				loading_type: 1, //下拉加载类型 1普通加载 2关键词搜索加载 3日期搜索加载
				url: 'http://kefu.tjztct.com',
				videoSrc: null, //视频播放路劲
			}
		},
		components: {
			Calendar
		},
		props: {
			msgkey: String,
			User_code: String,
			username:String,
			chat_name: String,
			friend_id:Number,//聊天对象id 
		},
		methods: {
			// 播放语音
			playAudio(src) {
				console.log(this.URL + src)
				console.log(src)
				this.$refs.audio.src = 'http://kefu.tjztct.com/' + src
				var BenzAMRRecorder = require('benz-amr-recorder');
				let amr = new BenzAMRRecorder()
				amr.initWithUrl('v1' + src).then(function () {
					amr.play()
				})
			},
			closeVideo() {
				this.videoSrc = null
			},
			// 播放视频
			playVideo(src) {
				this.videoSrc = this.url + src
			},
			// 选中某一天
			async choseDay(data) {
				this.show_calendar = false;
				this.date = data;
				this.page = 0;
				this.searchByDate();
			},
			// 切换显示输入框
			toggleSearch() {
				this.show_search_input = !this.show_search_input;
				this.show_calendar = false;
				if (this.show_search_input) {
					this.page = 0;
				}
			},
			// 切换显示日历
			toggleCalendar() {
				this.show_calendar = true;
				this.show_search_input = false;
			},
			// 切换显示搜索时间段
			toggleSearchTime(e) {
				if (e.target.dataset.time) {
					this.time = e.target.dataset.time;
					this.chatTimeRound = e.target.dataset.text
				}
				this.showSearchTime = !this.showSearchTime;
			},
			// 触底加载
			bottomLoading() {
				this.page++;
				if (this.loading_type == 1) {
					// 普通下拉加载
					this.loadChatList()
				} else if (this.loading_type == 2) {
					// 关键词下拉加载
					this.searchByTime();
				} else {
					//日期搜索下拉加载
					this.searchByDate();
				}
			},
			// 根据日期搜索
			async searchByDate() {
				var that = this;
				this.loading_type = 3;
				var res = await this.$axios.post('/iMessage/seachMsgHis', {
					msgkey: this.msgkey,
					type: '2',
					time: that.date,
					page: this.page,
					limit: this.limit
				})
				this.processingMessage(res,'history');
			},
			// 根据时间段搜索
			async searchByTime() {
				var that = this;
				this.loading_type = 2;
				var res = await this.$axios.post('/iMessage/seachMsgHis', {
					msgkey: this.msgkey,
					type: '1',
					search_str: this.search_str,
					time_type: this.time,
					page: this.page,
					limit: this.limit
				})
				this.processingMessage(res,'history')
			},
			// 加载订单信息
			async getCheckOrder(order_id, id) {
				var that = this;
				var res = await this.$axios.post('/checkOrder/createOrder', {
					User_code: that.User_code,
					order_id: order_id,
				})
				if (res.data.done) {
					var orderInfo = {};
					if (res.data.data.check.res[0].id == 1) {
						orderInfo.id = res.data.data.order.order[0].order_id
					}
					if (res.data.data.check.res[0].open_sku == 1) {
						orderInfo.open_sku = res.data.data.order.goods[0].specification
					}
					if (res.data.data.check.res[0].open_specprice == 1) {
						orderInfo.open_specprice = res.data.data.order.goods[0].price
					}
					if (res.data.data.check.res[0].open_quantity == 1) {
						orderInfo.open_quantity = res.data.data.order.goods.length
					}
					if (res.data.data.check.res[0].open_orderprice == 1) {
						orderInfo.open_orderprice = res.data.data.order.order[0].goods_amount
					}
					if (res.data.data.check.res[0].open_actualprice == 1) {
						orderInfo.open_actualprice = res.data.data.order.order[0].order_amount
					}
					if (res.data.data.check.res[0].open_address == 1) {
						orderInfo.open_address = res.data.data.order.order[0].address
					}
					orderInfo.goods_name = res.data.data.order.goods[0].goods_name
					orderInfo.goods_image = res.data.data.order.goods[0].goods_image
					orderInfo.consignee = res.data.data.order.order[0].consignee
					orderInfo.phone_mob = res.data.data.order.order[0].phone_mob
					that.chatList.forEach(function(item, index) {
						item.forEach(function(item, index) {
							if (item.id == id) {
								item.message = orderInfo
							}
						})
					})
				} else {
					that.$message.error(res.data.msg)
				}
			},
			// 处理聊天消息的方法
			processingMessage(res,type) {
				var that = this;
				if (!res.data.done) {
					this.$message.error(res.data.msg);
					return
				}
				// this.chatList = res.data.data
				if(type=='history'){
					//查找
					if (res.data.data.res.length == 0) {
						return
					}
					res.data.data.res = res.data.data.res.reverse();
					var startTime = res.data.data.res[0].add_time;
					var historyArray = res.data.data.res
				}else if(type=='normal'){
					//分页
					if (res.data.data.msglog.length == 0) {
						return
					}
					res.data.data.msglog = res.data.data.msglog.reverse();
					var startTime = res.data.data.msglog[0].add_time;
					var historyArray = res.data.data.msglog
				}
				
				var i = 0; //时间数组的起始项
				res.data.time = []; //定义外层的时间数组
				historyArray.forEach(function(item, index) {
					if (res.data.time[i] == undefined) {
						res.data.time[i] = []
					}
					if (item.msg_type == 4) {
						//订单信息块
						that.getCheckOrder(item.message, item.id)
					}
					if (item.msg_type == 6) {
						//商品信息块
						console.log()
						var obj = {}
						item.message.split(',').forEach(function(item, index) {
							var arr = item.split(':')
							if (arr[1] == 'http' || arr[1] == 'https') {
								obj[arr[0]] = arr[1] + ':' + arr[2]
							} else {
								obj[arr[0]] = arr[1]
							}
						})
						console.log(obj)
						item.message = obj
					}
					if (item.msg_type == 5) {
						//表情包
						var tempEmoji = item.message.split('/')
						item.message = require('@/static/emoji/' + tempEmoji[tempEmoji.length - 1])
					}
					if (item.add_time - startTime < 1800) {
						item.add_time = that.formatDateTime(item.add_time)
						item.add_time_hour = item.add_time.substr(11, 8)
						res.data.time[i].push(item)
					} else {
						startTime = item.add_time; //改变起始时间
						res.data.time[++i] = [];
						item.add_time = that.formatDateTime(item.add_time)
						res.data.time[i].push(item); //数组下标加一
					}
				})
				if (that.page > 0) {
					// 不是初始加载
					that.chatList = res.data.time.concat(that.chatList)
				} else {
					that.chatList = res.data.time
				}
				// that.page+=10;
			},
			// 加载聊天记录列表
			async loadChatList() {
				var that = this;
				this.loading_type = 1;
				console.log(that.msgkey)
				if (!that.msgkey) {
					return
				}
				console.log(that.chatList)
				console.log(that.chatList.length)
				var chatListLength = 0;
				if(that.chatList.length>0){
					//消息数组有内容时
					that.chatList.forEach(function(item,index){
						chatListLength+=item.length
					})
				}
				console.log("chatListLength:"+chatListLength)
				var res = await this.$axios.post('/iMessage/loadMsg', {
					page: chatListLength,
					msgkey: this.msgkey,
					limit: this.limit,
					to_id:this.friend_id
				})
				if(res.data.data.msglog.length==0){
					this.$message.warning('没有更多消息了')
				}
				this.processingMessage(res,'normal')
			},
			formatDateTime(timeStamp) {
				var date = new Date();
				date.setTime(timeStamp * 1000);
				var y = date.getFullYear();
				var m = date.getMonth() + 1;
				m = m < 10 ? ('0' + m) : m;
				var d = date.getDate();
				d = d < 10 ? ('0' + d) : d;
				var h = date.getHours();
				h = h < 10 ? ('0' + h) : h;
				var minute = date.getMinutes();
				var second = date.getSeconds();
				minute = minute < 10 ? ('0' + minute) : minute;
				second = second < 10 ? ('0' + second) : second;
				return y + '/' + m + '/' + d + ' ' + h + ':' + minute + ':' + second;
			},
		},
		created() {
			console.log(this.friend_id)
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.clearfix:after {
		content: ' ';
		display: block;
		clear: both;
		visibility: hidden;
		line-height: 0;
		height: 0;
	}

	.chat-record-title {
		height: 45px;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: #fff;
		color: #333;
		font-size: 18px;
		border: 1px solid #eee;
		box-sizing: border-box;
	}
	.self-name{
		color: #4b73ec !important;
		font-size: 14px !important;
	}
	.chat-name{
		color: #888888 !important;
		font-size: 14px !important;
	}

	.chat-record-list {
		width: 100%;
		box-sizing: border-box;
		margin: 0;
		list-style: none;
		overflow-y: auto;
		padding: 0;
	}

	.no_input {
		height: calc(100% - 85px) !important;
	}

	.has_input {
		height: calc(100% - 150px) !important;
	}

	.chat-record-item {
		list-style: none;
		width: 100%;
		box-sizing: border-box;
		padding-left: 24px;
		height: 32px;
		line-height: 32px;
		font-size: 18px;
		color: #333;
	}

	/* 消息内容快 */
	.message-time {
		width: 100%;
		box-sizing: border-box;
		height: 40px;
		line-height: 40px;
		text-align: center;
		font-size: 14px;
		color: #888;
	}

	.message-item {
		width: 100%;
		/* height: 50px; */
		line-height: 50px;
		box-sizing: border-box;
		padding-left: 17px;
		margin-bottom: 15px;
	}

	.message-item-name {
		height: 20px;
		line-height: 20px;
		font-size: 14px;
		color: #888;
		box-sizing: border-box;
	}

	.message-item-content {
		/* height: 30px; */
		width: 100%;
		line-height: 30px;
		font-size: 18px;
		color: #333;
		box-sizing: border-box;
		text-align: justify;
		text-justify: newspaper;
		word-break: break-all;
	}

	.message-item-name span {
		color: #888;
		font-size: 12px;
	}

	/* 底部搜索 */
	.chat-foot {
		background-color: #fff;
		width: 100%;
		box-sizing: border-box;
		max-height: 105px;
		height: auto;
	}

	.foot-search {
		width: 100%;
		height: 65px;
		background-color: #fff;
		padding-top: 22px;
		box-sizing: border-box;
	}

	.input-box {
		height: 35px;
		line-height: 35px;
		margin: 0px 15px 11px 15px;
		border-radius: 17.5px;
		box-sizing: border-box;
		background-color: #f5f5f5;
		width: calc(100% - 30px);
		display: flex;
	}

	.foot-bar {
		height: 40px;
		line-height: 40px;
		background-color: #fff;
		box-sizing: border-box;
		padding-left: 10px;
		position: relative;
	}

	.foot-bar .iconziyuan {
		color: #5792fa;
		font-size: 18px;
		margin-right: 17px;
	}

	.foot-bar .iconrili {
		font-size: 18px;
	}

	.input-box .choose-time {
		width: 96px;
		height: 100%;
		display: inline-block;
		line-height: 35px;
		position: relative;
	}

	.choose-time span {
		width: calc(100% - 20px);
		display: inline-block;
		text-align: center;
		font-size: 14px;
	}

	.choose-time i {
		width: 20px;
		height: 20px;
		display: inline-block;
	}

	.input-box .input-text {
		width: 68%;
		height: 100%;
		padding: 0;
		background-color: #F5F5F5;
		border: none;
		outline: none;
		font-size: 18px;
	}

	.input-box .iconyoujiantou {
		width: 8%;
		height: 100%;
		line-height: 35px;
		display: inline-block;
		font-size: 24px;
	}

	.time-quantum {
		position: absolute;
		top: -165px;
		left: 0;
		background-color: #fff;
		width: 96px;
		height: 160px;
		display: flex;
		border-radius: 5px;
		flex-direction: column;
		justify-content: space-around;
		line-height: 19px;
	}

	.time-quantum-item {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 14px;
	}

	.calendar {
		position: absolute;
		top: -200px;
		right: 24px;
	}

	.video {
		position: absolute;
		width: 500px;
		height: 400px;
		z-index: 9;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		object-fit: fill !important;
	}

	.close-video {
		position: absolute;
		font-size: 30px;
		z-index: 9;
		top: 50%;
		left: 50%;
		transform: translate(270px, -200px);
	}

	.message-goods {
		width: 100%;
	}

	.goods-left {
		width: 50px;
		height: 50px;
		float: left;
	}

	.goods-left img {
		width: 100%;
		height: 100%;
	}

	.goods-right {
		width: calc(100% - 50px);
		float: left;
		height: 50px;
		display: flex;
		flex-wrap: wrap;
	}

	.msg-goods-name,
	.msg-goods-price {
		width: 100%;
		height: 50%;
		align-items: center;
		display: flex;
	}
</style>
